import React, { memo } from "react";
import { Handle, Position } from "reactflow";

// Status palette — mirrors the spec (Wave Y).
const STATUS_PALETTE = {
  not_started:       { fill: "#1a1f29", stroke: "#3b4252", text: "#94a3b8", label: "LOCKED",   icon: "○" },
  ready:             { fill: "#0b1c2c", stroke: "#3b82f6", text: "#3b82f6", label: "READY",    icon: "◇" },
  in_progress:       { fill: "#2a2210", stroke: "#eab308", text: "#fbbf24", label: "ACTIVE",   icon: "◐" },
  complete:          { fill: "#0f2413", stroke: "#22c55e", text: "#22c55e", label: "COMPLETE", icon: "✓" },
  approved:          { fill: "#0f2413", stroke: "#22c55e", text: "#22c55e", label: "APPROVED", icon: "✓" },
  revision_required: { fill: "#2a1a0c", stroke: "#f97316", text: "#fb923c", label: "REVISION", icon: "↻" },
  blocked:           { fill: "#2a0f10", stroke: "#ef4444", text: "#f87171", label: "BLOCKED",  icon: "■" },
  waiting:           { fill: "#1a1f29", stroke: "#475569", text: "#94a3b8", label: "WAITING",  icon: "⌛" },
};

function StageNodeImpl({ data }) {
  const palette = STATUS_PALETTE[data.status] || STATUS_PALETTE.not_started;
  const cp = !!data.is_critical_path;
  const dim = !!data.dim;
  const highlight = !!data.highlight;

  return (
    <div
      data-testid={`fishbone-stage-${data.code}`}
      style={{
        minWidth: 150,
        padding: "8px 12px",
        background: palette.fill,
        border: `${cp ? 2.5 : 1.5}px solid ${highlight ? "#f59e0b" : palette.stroke}`,
        borderRadius: 8,
        color: palette.text,
        fontFamily: "'JetBrains Mono', monospace",
        boxShadow: cp ? "0 0 0 1px rgba(59,130,246,0.25)" : "none",
        opacity: dim ? 0.18 : 1,
        transition: "opacity 0.18s ease, border-color 0.15s ease",
        cursor: "pointer",
      }}
    >
      <Handle type="target" position={Position.Left}  style={{ background: "#475569", width: 6, height: 6 }} />
      <Handle type="source" position={Position.Right} style={{ background: "#475569", width: 6, height: 6 }} />
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 6 }}>
        <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.04em" }}>{data.code}</span>
        <span title={palette.label} style={{ fontSize: 12, opacity: 0.9 }}>{palette.icon}</span>
      </div>
      <div
        style={{
          fontSize: 11.5,
          color: "#e2e8f0",
          marginTop: 3,
          maxWidth: 180,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontFamily: "system-ui, -apple-system, sans-serif",
        }}
      >
        {data.name}
      </div>
      {data.status === "in_progress" && (
        <div
          style={{
            marginTop: 5,
            height: 3,
            background: "#1f2937",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <div style={{ width: `${data.progress || 0}%`, height: "100%", background: palette.text }} />
        </div>
      )}
      {cp && (
        <div style={{ fontSize: 9, color: "#60a5fa", marginTop: 4, letterSpacing: "0.08em", textTransform: "uppercase" }}>
          ★ Critical Path
        </div>
      )}
    </div>
  );
}

export default memo(StageNodeImpl);
